export default "__VITE_ASSET__CQuF1ug7__"